/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.0.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../reducers/rootReducer';
import { INotificationState } from './notificationReducer';
import { ENotificationPlace, INotification } from './types/notificationTypes';

export const getNotificationState = (state: IRootReducer) => state.notification;

export const makeSelectIsOpenNotification = (place: ENotificationPlace):
    OutputSelector<IRootReducer, boolean, (state: INotificationState) => boolean> =>
    createSelector(
        getNotificationState,
        (state: INotificationState) => {
            return state[place].isOpen;
        },
    );

export const makeSelectNotificationCurrentShowing = (place: ENotificationPlace):
    OutputSelector<IRootReducer, INotification[] | INotification | undefined,
        (state: INotificationState) => INotification[] | INotification | undefined> =>
    createSelector(
        getNotificationState,
        (state: INotificationState) => state[place].currentShowing,
    );

export const makeSelectNotificationIsEnabled = (place: ENotificationPlace):
    OutputSelector<IRootReducer, boolean, (state: INotificationState) => boolean> =>
    createSelector(
        getNotificationState,
        (state: INotificationState) => state[place].isEnabled,
    );
